import React from "react";
import { FiDownload } from "react-icons/fi";
import { sortByMonthYear } from "../utils";

const CashInTable = ({ chart5, reportLink }) => {
  if (!chart5?.length) return null;

  const sorted = sortByMonthYear(chart5);

  const categorySet = new Set();
  sorted.forEach((entry) => {
    entry.data?.forEach((row) => {
      if (row.Category !== "Total Collection") categorySet.add(row.Category);
    });
  });
  const categories = [...categorySet, "Total Collection"];

  const lookup = {};
  sorted.forEach((entry) => {
    lookup[entry.MonthYear] = {};
    entry.data?.forEach((row) => {
      lookup[entry.MonthYear][row.Category] = Number(row.Value || 0);
    });
  });

  const categoryColors = {
    Onshore: "text-blue-600",
    Service: "text-emerald-600",
    "Advance on New Orders": "text-amber-600",
    "Total Collection": "text-slate-800",
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">
          Overall Cash In Summary
        </p>
        <h2 className="text-base font-semibold text-slate-800 mt-0.5">
          Cash In – Service &amp; Onshore (All Months)
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-100 bg-slate-50">
              <th className="py-3 pl-5 pr-2 text-left font-semibold text-xs uppercase tracking-wider text-slate-400 w-8">
                #
              </th>
              <th className="py-3 px-4 text-left font-semibold text-xs uppercase tracking-wider text-slate-400">
                Category
              </th>
              {sorted.map((entry) => (
                <th
                  key={entry.MonthYear}
                  className="py-3 px-4 text-right font-semibold text-xs uppercase tracking-wider text-slate-400"
                >
                  {entry.MonthYear?.replace("_", " ")} Actual
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {categories.map((cat, idx) => {
              const isTotal = cat === "Total Collection";
              return (
                <tr
                  key={cat}
                  className={`border-b border-slate-100 ${isTotal ? "bg-slate-50 font-bold" : "hover:bg-slate-50/50"}`}
                >
                  <td className="py-3 pl-5 pr-2 text-slate-400">
                    {isTotal ? "—" : idx + 1}
                  </td>
                  <td
                    className={`py-3 px-4 font-medium ${categoryColors[cat] || "text-slate-700"}`}
                  >
                    {cat}
                  </td>
                  {sorted.map((entry) => (
                    <td
                      key={entry.MonthYear}
                      className={`py-3 px-4 text-right tabular-nums ${isTotal ? "text-slate-800" : "text-slate-600"}`}
                    >
                      {(lookup[entry.MonthYear]?.[cat] ?? 0).toFixed(2)}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="flex justify-end px-5 py-3 border-t border-slate-100 bg-slate-50">
        {reportLink ? (
          <a
            href={reportLink}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-lg bg-[#0060D0] px-4 py-2 text-sm font-semibold !text-white shadow-sm transition hover:bg-[#0050b0]"
          >
            <FiDownload className="h-4 w-4" />
            Download Final Consolidated Report
          </a>
        ) : (
          <button
            type="button"
            disabled
            title="Report link not available from API"
            className="inline-flex items-center gap-2 rounded-lg bg-slate-300 px-4 py-2 text-sm font-semibold text-white shadow-sm cursor-not-allowed"
          >
            <FiDownload className="h-4 w-4" />
            Download Report
          </button>
        )}
      </div>
    </div>
  );
};

export default CashInTable;
